import { createReducer } from 'redux-starter-kit';
import { SET_QUESTIONS, SET_RESPONSES } from './actions';
import { QuestionType, ResponseType } from './types';

interface StateType {
  questions: QuestionType[];
  responses: ResponseType[];
}

const INITIAL_STATE = {
  questions: [],
  responses: []
};

export default createReducer(INITIAL_STATE, {
  [SET_QUESTIONS]: (state, action) => {
    state.questions = action.payload.sort(
      (a: QuestionType, b: QuestionType) => a.value - b.value
    );
  },
  [SET_RESPONSES]: (state, action) => {
    state.responses = action.payload;
  }
});
